/**
 * Shared SRS seat-square helpers for Crowd Count tile overlays.
 */
import colorForLabel from '../helpers/labelColor';

const avg = (xs) => (xs.length ? xs.reduce((s, n) => s + n, 0) / xs.length : 0);

/** Avg consecutive-seat pitch in a region → square edge length. */
export const regionPitch = (seats, {
  xKey = 'xPx',
  yKey = 'yPx',
  rowKey = 'row',
  seatKey = 'seat',
} = {}) => {
  const byRow = new Map();
  seats.forEach((s) => {
    const list = byRow.get(s[rowKey]) || [];
    list.push(s);
    byRow.set(s[rowKey], list);
  });
  const gaps = [];
  byRow.forEach((list) => {
    list.sort((a, b) => a[seatKey] - b[seatKey] || a[xKey] - b[xKey]);
    for (let i = 1; i < list.length; i += 1) {
      if (list[i][seatKey] - list[i - 1][seatKey] === 1) {
        const d = Math.hypot(
          list[i][xKey] - list[i - 1][xKey],
          list[i][yKey] - list[i - 1][yKey],
        );
        if (d > 1) gaps.push(d);
      }
    }
  });
  return gaps.length ? avg(gaps) : null;
};

/** Seat square on a tile (normalized x/y within tile). */
export const seatSquareStyleTile = (seat, tileW, tileH, borderColor) => {
  const size = seat.sizePx || 0.08 * Math.min(tileW, tileH);
  return {
    left: `${seat.x * 100}%`,
    top: `${seat.y * 100}%`,
    width: `${(size / tileW) * 100}%`,
    transform: 'translate(-50%, -50%)',
    borderColor: borderColor || colorForLabel(seat.section || '?'),
  };
};
